import { useQueryClient } from '@tanstack/react-query'

import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  Chat,
  MutationUnarchiveChatArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatsKey } from '../../utils/keys/index.js'
import { useRefreshChats } from './useRefreshChats.js'

export const useUnarchiveChat = (
  options?: UseMutationOptions<Chat, ClientError, MutationUnarchiveChatArgs>,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const chatsKey = getChatsKey()
  const { refreshChat } = useRefreshChats()

  return useMutation<Chat, ClientError, MutationUnarchiveChatArgs>(
    (input: MutationUnarchiveChatArgs) => client.messaging.unarchiveChat(input),
    {
      ...(options ?? {}),
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(chatsKey)
        await refreshChat(variables.chatId)
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context)
        }

        return data
      },
    },
  )
}
